!function(module){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('flights/flightPers',['libs/ct_pers'], module)
	else
	//>>excludeEnd("requireTmpl");
		module(CT.Pers)
}(function(Pers, nope){
	
	/**
	 * This contains methods that will update an item(s) based on the type of personalization
	 */
	var updaters = {
		'recent' : function(item, table){
			var newItem = {
				tt : item.trip_type,
				ftg : item.origin,
				fr : item.from,
				ttg : item.destination,
				to : item.to,
				dt : item.depart_date,
				rt : item.return_date,
				ad : item.adults,
				cd : item.childs,
				inf : item.infants,
				intl : item.intl,
				sd : moment().format("MM/DD/YYYY"),//current time stamp
				fl: {
					al: item.airline,
					carr: item.carrier,
					cot: item['class']
				},
				lng:CT.langUrlPrefix
			}
			return newItem
		},
		
		'shortlisted' : function(item, table){
			var obj = {}
			var data = {}
			var key = item.cid? item.cid + '-' + item.cod : '-'
			data[key] = item.hids
			obj[item.name] = data
			return obj
		},
		'last_booked' : function(item, table){
			return item
		},
		'filter_applied' : function(item, table) {
				return item
		},
		'guided_nav' : function(){
			
		},
		'bookflow_dropoff' : function(){
			
		},
		'upcoming_trips' : function(){
			
		},
		'default_pref' : function(){
			
		},
		'last_refund_up' : function(item, table){
			return item
		},
		'last_completed' : function(item){
			return item
		},
		'filters' : function(){
			
		},
		'threshold' : function(){
			
		}
	}
	
	
	
	
	
	
	
	
	
	
	// This will update the array containing personalization objects before storing in the database
	var arrayUpdaters = {
		'recent' : function(arr, item, table){
			arr.unshift(item)
			if(arr.length > 10) arr.length = 10
			return _(arr).uniq(function(val){ return _.serialize(val) }).value()
		},
		
		'shortlisted' : function(arr, item, table){
			var hash = arr[0]
			var toUpdate = (typeof hash[item.name] != 'undefined') ? hash[item.name]  : hash;


			$.extend(toUpdate, item)
			arr[0] = hash
			return arr  
		},
		
		'last_booked' : function(arr, item, table){
			return arr
		},
		
		'filter_applied' : function(arr, item, table){
			arr.unshift(item)
			if(arr.length > 10) arr.length = 10
			return _(arr).uniq(function(val){ return _.serialize(val) }).value()
		}, 
		
	}
	
	
	
	
	
	
	// Expiry modifiers
	var expMods = {}
	
	
	
	
	
	
	
	
	
	
	
	
	var expChecks = {
		'recent' : function(item){
			var isPastDepDate;
			if(item.dt)
				isPastDepDate = +new Date() > (+new Date(CT.utils.swapDayMonth(item.dt)) + 86399000)
			return (isPastDepDate) ? nope : item
		},
	
		'filter_applied' : function(item){
			return item
		}
	}
	
	
	
	
	
	
	_.each(updaters, function(fn, key){
		Pers.add(key, fn)
	})
	_.each(arrayUpdaters, function(fn, key){
		Pers.add(key, fn, 'array')
	})
	_.each(expMods, function(fn, key){
		Pers.add(key, fn, 'expires')
	})
	_.each(expChecks, function(fn, key){
		Pers.add(key, fn, 'expiryCheck')
	})
	
	return Pers
})
;
